/*eslint-disable*/
export function updateStandardDataLayerAttributes(params, triggerStandardCallRule) {
    let dataLayer = window['digitalData'];
    if (typeof _satellite !== 'undefined') {
        Object.keys(params).map(key => {
            return dataLayer[key] = params[key];
        });
    }
}

export function fireDirectCallRule(ruleName) {
    try {
        if (typeof _satellite !== 'undefined') {
            _satellite.track(ruleName);
        }
    } catch(e) {
        console.error("fireDirectCallRule",e);
    }
}

export function setDataLayer(attr, jsonResponse) {
    let dataLayer = window['digitalData'];
    dataLayer[attr] = jsonResponse;
}

export function getCurrentPageNameSiteSection(){
    let digitalData = window['digitalData'];
    if(digitalData){
        return {
            pageName:digitalData.pageInfo.pageName,
            siteSection:digitalData.pageInfo.siteSection
        }
    } else {
        return;
    }
}

export function setPageNameSiteSection (pageName,siteSection) {
    let digitalData = window['digitalData'];
    if(digitalData){
        digitalData.pageInfo.pageName=pageName;
        digitalData.pageInfo.siteSection=siteSection;
        return digitalData;
    } else {
        return;
    }
};

export function setCustomDataLayer (pageName,siteSection,previousPagevalue) {
    let digitalData = window['digitalData'];
    if(digitalData){
        digitalData.pageInfo.pageName=pageName;
        digitalData.pageInfo.siteSection=siteSection;
        digitalData.pageInfo.previousPagevalue=previousPagevalue;
        return digitalData;
    } else {
        return;
    }
};

export function setBankDetailsDataLayer (pageName, siteSection, term, amount) {
    let digitalData = window['digitalData'];
    if(digitalData){
        digitalData.pageInfo.pageName=pageName;
        digitalData.pageInfo.siteSection=siteSection;
        digitalData.productInfo.productPurchaseChannel=term;
        digitalData.productInfo.productAmount=amount;
        return digitalData;
    } else {
        return;
    }
};

export function setNewBankAccountDataLayer (bankAccount, status) {
    let digitalData = window['digitalData'];
    if(digitalData){
        digitalData.pageInfo.previousPagevalue=bankAccount;
        digitalData.productInfo.productPurchaseFlow=status;
        return digitalData;
    } else {
        return;
    }
};

export function setSuccessDataLayer (pageName, siteSection, flowStatus) {
    let digitalData = window['digitalData'];
    if(digitalData){
        digitalData.pageInfo.pageName=pageName;
        digitalData.pageInfo.siteSection=siteSection;
        digitalData.productInfo.productPurchaseFlow=flowStatus;
        return digitalData;
    } else {
        return;
    }
};
